import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {setActiveLobbyTab, setSelectedAbroadPackage} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers.js';
import {Swiper, SwiperSlide} from 'swiper/react';
import AbroadPackage from '../CellcomAbroadLobbyBlock/Shared/Components/AbroadPackage';
import {Navigation} from 'swiper';

const AbroadPopularSwiper = (props) => {
  const {gtag4, textTab, switchExtraction} = props;
  const [aboardPackages, setAboardPackages] = useState();
  const abroadPackagesPopularMarket = props?.cellcomAbroad?.abroadPackagesPopularMarket;

  useEffect(() => {
    if (abroadPackagesPopularMarket !== undefined) {
      let packageData = abroadPackagesPopularMarket[props?.blockID]?.map((item) => item);
      setAboardPackages(packageData);
    }
  }, [abroadPackagesPopularMarket]);

  //Pressing a button in the package
  const orderEvent = (packageData) => {
    const queryUrl = `?blockId=${props?.lobbyFolderReference?.value?.id}?clientType=${'private'}`;
    props?.setActiveLobbyTab('private');
    props?.setSelectedAbroadPackage({
      selectedPackage: packageData,
      folderType: 'private',
      startedFromPackage: true,
      selectedOnSalePageFlag: true,
    });
    prepareUrl(props?.lobbyFolderReference?.value?.url, props?.context, queryUrl);
    gtag4({
      event: 'CarouselPackagesSale_ContinueButton',
      category: textTab,
      section: 'CarouselPackagesSale',
      button: packageData?.buttonValue,
      package_name: switchExtraction(packageData?.titleEpi),
      badge: 'no badge',
    });
  };

  return (
    <Swiper
      className='swiper-item'
      modules={[Navigation]}
      navigation={aboardPackages?.length > 1 ? true : false}
      enabled={true}
      centerInsufficientSlides={true}
      spaceBetween={15}
      slidesPerView={'auto'}
      slidesOffsetBefore={15}
      slidesOffsetAfter={15}>
      {aboardPackages?.map((item, i) => (
        <SwiperSlide key={i}>
          <AbroadPackage
            packageData={item}
            orderEvent={orderEvent}
            supportedApps={props?.cellcomAbroad?.getEpiGeneralData?.supportedApps}
            context={props?.context}
            isSearchOrPopular={'PopularMarket'}
            isPrivateOrBusiness={props?.cellcomAbroad?.activeLobbyTab}
            isSeparatedSale={props?.cellcomAbroad?.otpData?.validatedCostumerData?.isSeparatedSale}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const mapStateToProps = (state) => {
  return {
    cellcomAbroad: state?.cellcomAbroad,
  };
};

const mapDispatchToProps = {setActiveLobbyTab, setSelectedAbroadPackage};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadPopularSwiper);
